import * as React from 'react';
import { Handle, Position } from '@xyflow/react';
import { TerminalNode } from '../terminal-node/terminal-node.component';
import { floatingHandleStyles } from '../../styles/floating-handle-styles';

export const EndNode = () => (
  <>
    <Handle
      type="target"
      position={Position.Top}
      data-testid="end-node-handle"
      style={floatingHandleStyles.targetTop}
    />
    <TerminalNode type="end" />
  </>
);
